import NeedHelpColumn from "./needhelpcolumn";

import images from "../../assets";

import "./styles.css";

export default function NeedHelpCard(props) {
  const needHelpInfo = [
    {
      titleName: "Contact Us",
      values: "support@noblemarriage.net",
    },
    {
      titleName: "For Inquiries",
      values: "info@noblemarriage.com",
    },
    {
      titleName: "Success Stories",
      values: "info@noblemarriage.com",
    },
  ];
  return (
    <div className="need-help-body">
      <div {...props} className="need-help-inner">
        <div className="need-help-head">
          <h2>Need Help?</h2>
        </div>
        {needHelpInfo?.map((item, index) => (
          <NeedHelpColumn
            titlename={item?.titleName}
            values={item?.values}
            key={index}
          />
        ))}
        <a
          className="need-help-whatsapp"
          href={props?.whatsapplink ?? "https://wa.me/447501247364"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={images.whatsAppBtn} alt="" />
        </a>
      </div>
    </div>
  );
}
